import React, { useState } from "react";
import styled from "styled-components";
import { useTypedSelector } from "store";
import { ActionButton, LoaderSpinner2, Modal } from "components";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { api } from "../../../../api/api";
import {
  exportToTSVFile,
  getFilenameFromContentDisposition,
} from "../../../../api/helpers";

enum ExportStates {
  IDLE,
  PENDING,
  SUCCESS,
  ERROR,
}

export default function ExportRuleTableToTSVButton({
  ruleTableId,
}: {
  ruleTableId: string;
}) {
  const [exportStatus, setExportStatus] = useState(ExportStates.IDLE);
  const [exportError, setExportError] = useState<any>(undefined);

  const closeExportErrorModal = () => {
    setExportStatus(ExportStates.IDLE);
  };

  const { selectedProductLine: productLine } = useTypedSelector(
    (state) => state.products
  );

  const handleExport = async () => {
    if (!productLine) {
      setExportStatus(ExportStates.ERROR);
      setExportError("No product line selected.");
      return;
    }

    setExportStatus(ExportStates.PENDING);

    try {
      //Call the api to export the table
      const res = await api.exportRuleTableToTSV(productLine?.id, ruleTableId);

      if (res.status === 400) {
        setExportStatus(ExportStates.ERROR);
        setExportError(res.data);
        return;
      }

      setExportStatus(ExportStates.SUCCESS);

      const filename = getFilenameFromContentDisposition(
        // it is lowercase in local and capitalized when deployed
        res.headers["content-disposition"] || res.headers["Content-Disposition"]
      );
      exportToTSVFile(res.data, filename || productLine?.name);
    } catch (e) {
      console.error(e, "error while exporting product line");
    }
  };

  return (
    <Wrapper>
      <ActionButton
        tooltipText="Export Table to TSV"
        tooltipArrow
        tooltipPlacement="bottom"
        ariaLabel="Export table to TSV"
        icon={FileDownloadIcon}
        iconOnly
        size="medium"
        color="primary"
        disabled={exportStatus === ExportStates.PENDING}
        onClick={() => handleExport()}
      />
      {exportStatus === ExportStates.PENDING && <LoaderSpinner2 />}
      {exportStatus === ExportStates.ERROR && (
        <Modal
          open={exportStatus === ExportStates.ERROR}
          closeModal={closeExportErrorModal}
          title={"Export tool error"}
        >
          {typeof exportError !== undefined && exportError}
        </Modal>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
